<template>
  <SpectreToastGroup />
  <div class="flex min-h-dvh flex-col">
    <SpectreNavigation
      ref="navElement"
      :links="page.props.navigation"
      :system-alerts="page.props.systemAlerts ?? []"
      product="property_reports"
      :user="{ name: page.props.auth.user?.name ?? '', roles: page.props.auth.user?.roles ?? [] }"
      :environment="page.props.app.env"
      @request-access="handleRequestAccess"
    />
    <slot />
  </div>
</template>

<script setup lang="ts">
import type {
  ComponentPublicInstance } from 'vue';
import {
  nextTick,
  onMounted,
  ref,
} from 'vue';
import { route } from 'ziggy-js';
import { usePage } from '@inertiajs/vue3';
import useProductAccessRequest from '@/Composables/useProductAccessRequest';
import {
  SpectreNavigation, SpectreToastGroup,
} from '@agentsoftware/spectre-ui';
import useToastQueue from '@/Stores/ToastQueue';
import { trackUser } from '@/Support/MixpanelTracking';
import { whenever } from '@vueuse/core';
import { useNavigationBarStore } from '@/Stores/NavigationBar';

const page = usePage();

const { enqueue } = useToastQueue();

whenever(() => page.props.flash?.toasts, (newValue) => {
  newValue.forEach((toast) => {
    enqueue({ label: toast.label, description: toast.description, type: toast.type });
  });
});

const { requestAccess: handleRequestAccess } = useProductAccessRequest();

if (page.props.auth.user?.id) {
  trackUser(
    page.props.auth.user.id,
    {
      $email: page.props.auth.user.email,
      $name: page.props.auth.user.name,
    },
  );
}

const navElement = ref<ComponentPublicInstance>();
const navigationBarStore = useNavigationBarStore();

onMounted(() => {
  nextTick(() => {
    if (navElement.value) {
      navigationBarStore.setNavBarHeight(navElement.value?.$el.offsetHeight);
    }
  });
});
</script>

<style>
.mapboxgl-marker {
  outline: none;
}
</style>
